import { jsxs as V, jsx as C } from "react/jsx-runtime";
const f = ({ variant: i, width: e = 110, height: d = 35 }) => {
  const l = {
    brand: "#CB0000",
    light: "#fff",
    dark: "#090C10"
  }[i];
  return /* @__PURE__ */ V(
    "svg",
    {
      width: e,
      height: d,
      viewBox: "0 0 107 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80.2342 2.19585H82.0933V2.18866C82.2262 2.18866 82.3537 2.24168 82.4477 2.33606C82.5417 2.43043 82.5944 2.55844 82.5944 2.69191V23.4211C82.5938 23.6985 82.3696 23.9232 82.0933 23.9232H80.2342C79.9578 23.9232 79.7337 23.6985 79.733 23.4211V21.8634C78.2797 23.416 76.2563 24.3029 74.1343 24.3174C69.6453 24.3174 65.8508 20.4771 65.8508 15.9298C65.856 11.3381 69.5616 7.61707 74.1343 7.61179C76.2459 7.62008 78.2648 8.48421 79.733 10.0082V2.6991C79.733 2.42116 79.9574 2.19585 80.2342 2.19585ZM68.816 15.9359C68.816 18.9961 71.1738 21.4872 74.0663 21.4872C77.0088 21.4872 79.5946 18.9134 79.5946 15.943C79.5946 12.9726 77.0625 10.4635 74.0663 10.4635C71.1226 10.4635 68.816 12.8755 68.816 15.9359Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80.2342 2.19585H82.0933V2.18866C82.2262 2.18866 82.3537 2.24168 82.4477 2.33606C82.5417 2.43043 82.5944 2.55844 82.5944 2.69191V23.4211C82.5938 23.6985 82.3696 23.9232 82.0933 23.9232H80.2342C79.9578 23.9232 79.7337 23.6985 79.733 23.4211V21.8634C78.2797 23.416 76.2563 24.3029 74.1343 24.3174C69.6453 24.3174 65.8508 20.4771 65.8508 15.9298C65.856 11.3381 69.5616 7.61707 74.1343 7.61179C76.2459 7.62008 78.2648 8.48421 79.733 10.0082V2.6991C79.733 2.42116 79.9574 2.19585 80.2342 2.19585ZM68.816 15.9359C68.816 18.9961 71.1738 21.4872 74.0663 21.4872C77.0088 21.4872 79.5946 18.9134 79.5946 15.943C79.5946 12.9726 77.0625 10.4635 74.0663 10.4635C71.1226 10.4635 68.816 12.8755 68.816 15.9359Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80.2342 2.19585H82.0933V2.18866C82.2262 2.18866 82.3537 2.24168 82.4477 2.33606C82.5417 2.43043 82.5944 2.55844 82.5944 2.69191V23.4211C82.5938 23.6985 82.3696 23.9232 82.0933 23.9232H80.2342C79.9578 23.9232 79.7337 23.6985 79.733 23.4211V21.8634C78.2797 23.416 76.2563 24.3029 74.1343 24.3174C69.6453 24.3174 65.8508 20.4771 65.8508 15.9298C65.856 11.3381 69.5616 7.61707 74.1343 7.61179C76.2459 7.62008 78.2648 8.48421 79.733 10.0082V2.6991C79.733 2.42116 79.9574 2.19585 80.2342 2.19585ZM68.816 15.9359C68.816 18.9961 71.1738 21.4872 74.0663 21.4872C77.0088 21.4872 79.5946 18.9134 79.5946 15.943C79.5946 12.9726 77.0625 10.4635 74.0663 10.4635C71.1226 10.4635 68.816 12.8755 68.816 15.9359Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M62.1517 2.19592H60.2913C60.0145 2.19592 59.7902 2.42124 59.7902 2.69917V10.0083C58.3224 8.48436 56.3039 7.62021 54.1926 7.61186C49.6153 7.61518 45.9061 11.3419 45.9055 15.9382C45.9055 20.4855 49.6989 24.3257 54.189 24.3257C56.3106 24.311 58.3335 23.4241 59.7867 21.8719V23.4296C59.7873 23.707 60.0115 23.9316 60.2878 23.9316H62.1481C62.4239 23.9309 62.6474 23.7066 62.648 23.4296V2.70037C62.648 2.4229 62.4244 2.19778 62.1481 2.19712L62.1517 2.19592ZM54.1222 21.4872C51.2298 21.4872 48.8719 18.9962 48.8719 15.9359C48.8719 12.8756 51.1761 10.4564 54.1222 10.4564C57.1185 10.4564 59.6494 12.9655 59.6494 15.9359C59.6494 18.9063 57.0672 21.4872 54.1222 21.4872Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M62.1517 2.19592H60.2913C60.0145 2.19592 59.7902 2.42124 59.7902 2.69917V10.0083C58.3224 8.48436 56.3039 7.62021 54.1926 7.61186C49.6153 7.61518 45.9061 11.3419 45.9055 15.9382C45.9055 20.4855 49.6989 24.3257 54.189 24.3257C56.3106 24.311 58.3335 23.4241 59.7867 21.8719V23.4296C59.7873 23.707 60.0115 23.9316 60.2878 23.9316H62.1481C62.4239 23.9309 62.6474 23.7066 62.648 23.4296V2.70037C62.648 2.4229 62.4244 2.19778 62.1481 2.19712L62.1517 2.19592ZM54.1222 21.4872C51.2298 21.4872 48.8719 18.9962 48.8719 15.9359C48.8719 12.8756 51.1761 10.4564 54.1222 10.4564C57.1185 10.4564 59.6494 12.9655 59.6494 15.9359C59.6494 18.9063 57.0672 21.4872 54.1222 21.4872Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M62.1517 2.19592H60.2913C60.0145 2.19592 59.7902 2.42124 59.7902 2.69917V10.0083C58.3224 8.48436 56.3039 7.62021 54.1926 7.61186C49.6153 7.61518 45.9061 11.3419 45.9055 15.9382C45.9055 20.4855 49.6989 24.3257 54.189 24.3257C56.3106 24.311 58.3335 23.4241 59.7867 21.8719V23.4296C59.7873 23.707 60.0115 23.9316 60.2878 23.9316H62.1481C62.4239 23.9309 62.6474 23.7066 62.648 23.4296V2.70037C62.648 2.4229 62.4244 2.19778 62.1481 2.19712L62.1517 2.19592ZM54.1222 21.4872C51.2298 21.4872 48.8719 18.9962 48.8719 15.9359C48.8719 12.8756 51.1761 10.4564 54.1222 10.4564C57.1185 10.4564 59.6494 12.9655 59.6494 15.9359C59.6494 18.9063 57.0672 21.4872 54.1222 21.4872Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2771 7.86824H14.3118C14.179 7.86824 14.0517 7.9213 13.9579 8.01571C13.8641 8.11013 13.8115 8.23813 13.8118 8.37149V9.84529C12.3566 8.34837 10.3667 7.49654 8.28355 7.47882C3.79335 7.47882 0 11.3203 0 15.8664C0.00526051 20.4581 3.71085 24.1791 8.28355 24.1843C10.3544 24.1731 12.338 23.3457 13.8071 21.8802V22.272C13.8071 26.4238 12.0172 28.5291 8.48998 28.5291C7.65401 28.5303 6.83064 28.3246 6.09274 27.93C5.87877 27.8162 5.61435 27.8727 5.46509 28.0642L4.29332 29.5716C4.20346 29.6868 4.16801 29.8355 4.1962 29.9791C4.22438 30.1227 4.31341 30.2469 4.44009 30.3192C5.6785 31.0113 7.07272 31.3734 8.48998 31.3712C10.8622 31.3712 12.8836 30.6104 14.3369 29.1714C15.9323 27.5885 16.776 25.204 16.776 22.2757V8.37628C16.776 8.09834 16.5515 7.87304 16.2747 7.87304L16.2771 7.86824ZM8.21315 21.347C5.27178 21.347 2.96284 18.941 2.96284 15.8675C2.96284 12.7941 5.31593 10.3174 8.21315 10.3174C11.1581 10.3174 13.7403 12.9103 13.7403 15.8675C13.7403 18.8247 11.2095 21.347 8.21315 21.347Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2771 7.86824H14.3118C14.179 7.86824 14.0517 7.9213 13.9579 8.01571C13.8641 8.11013 13.8115 8.23813 13.8118 8.37149V9.84529C12.3566 8.34837 10.3667 7.49654 8.28355 7.47882C3.79335 7.47882 0 11.3203 0 15.8664C0.00526051 20.4581 3.71085 24.1791 8.28355 24.1843C10.3544 24.1731 12.338 23.3457 13.8071 21.8802V22.272C13.8071 26.4238 12.0172 28.5291 8.48998 28.5291C7.65401 28.5303 6.83064 28.3246 6.09274 27.93C5.87877 27.8162 5.61435 27.8727 5.46509 28.0642L4.29332 29.5716C4.20346 29.6868 4.16801 29.8355 4.1962 29.9791C4.22438 30.1227 4.31341 30.2469 4.44009 30.3192C5.6785 31.0113 7.07272 31.3734 8.48998 31.3712C10.8622 31.3712 12.8836 30.6104 14.3369 29.1714C15.9323 27.5885 16.776 25.204 16.776 22.2757V8.37628C16.776 8.09834 16.5515 7.87304 16.2747 7.87304L16.2771 7.86824ZM8.21315 21.347C5.27178 21.347 2.96284 18.941 2.96284 15.8675C2.96284 12.7941 5.31593 10.3174 8.21315 10.3174C11.1581 10.3174 13.7403 12.9103 13.7403 15.8675C13.7403 18.8247 11.2095 21.347 8.21315 21.347Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2771 7.86824H14.3118C14.179 7.86824 14.0517 7.9213 13.9579 8.01571C13.8641 8.11013 13.8115 8.23813 13.8118 8.37149V9.84529C12.3566 8.34837 10.3667 7.49654 8.28355 7.47882C3.79335 7.47882 0 11.3203 0 15.8664C0.00526051 20.4581 3.71085 24.1791 8.28355 24.1843C10.3544 24.1731 12.338 23.3457 13.8071 21.8802V22.272C13.8071 26.4238 12.0172 28.5291 8.48998 28.5291C7.65401 28.5303 6.83064 28.3246 6.09274 27.93C5.87877 27.8162 5.61435 27.8727 5.46509 28.0642L4.29332 29.5716C4.20346 29.6868 4.16801 29.8355 4.1962 29.9791C4.22438 30.1227 4.31341 30.2469 4.44009 30.3192C5.6785 31.0113 7.07272 31.3734 8.48998 31.3712C10.8622 31.3712 12.8836 30.6104 14.3369 29.1714C15.9323 27.5885 16.776 25.204 16.776 22.2757V8.37628C16.776 8.09834 16.5515 7.87304 16.2747 7.87304L16.2771 7.86824ZM8.21315 21.347C5.27178 21.347 2.96284 18.941 2.96284 15.8675C2.96284 12.7941 5.31593 10.3174 8.21315 10.3174C11.1581 10.3174 13.7403 12.9103 13.7403 15.8675C13.7403 18.8247 11.2095 21.347 8.21315 21.347Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M32.5984 7.86823H34.4575C34.7343 7.86823 34.9586 8.09353 34.9586 8.37147V23.439C34.9586 23.717 34.7343 23.9423 34.4575 23.9423H32.5984C32.3216 23.9423 32.0973 23.717 32.0973 23.439V22.4193C30.8229 23.5804 29.1679 24.1903 27.2741 24.1903C22.6539 24.1903 20.6815 22.0336 20.6815 17.001V8.37387C20.6815 8.09593 20.9058 7.87062 21.1826 7.87062H23.0429C23.3197 7.87062 23.544 8.09593 23.544 8.37387V17.001C23.544 19.8864 24.7981 21.3482 27.2741 21.3482C30.3849 21.3482 32.0973 19.5903 32.0973 16.3995V8.37147C32.0973 8.09353 32.3216 7.86823 32.5984 7.86823Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M32.5984 7.86823H34.4575C34.7343 7.86823 34.9586 8.09353 34.9586 8.37147V23.439C34.9586 23.717 34.7343 23.9423 34.4575 23.9423H32.5984C32.3216 23.9423 32.0973 23.717 32.0973 23.439V22.4193C30.8229 23.5804 29.1679 24.1903 27.2741 24.1903C22.6539 24.1903 20.6815 22.0336 20.6815 17.001V8.37387C20.6815 8.09593 20.9058 7.87062 21.1826 7.87062H23.0429C23.3197 7.87062 23.544 8.09593 23.544 8.37387V17.001C23.544 19.8864 24.7981 21.3482 27.2741 21.3482C30.3849 21.3482 32.0973 19.5903 32.0973 16.3995V8.37147C32.0973 8.09353 32.3216 7.86823 32.5984 7.86823Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M32.5984 7.86823H34.4575C34.7343 7.86823 34.9586 8.09353 34.9586 8.37147V23.439C34.9586 23.717 34.7343 23.9423 34.4575 23.9423H32.5984C32.3216 23.9423 32.0973 23.717 32.0973 23.439V22.4193C30.8229 23.5804 29.1679 24.1903 27.2741 24.1903C22.6539 24.1903 20.6815 22.0336 20.6815 17.001V8.37387C20.6815 8.09593 20.9058 7.87062 21.1826 7.87062H23.0429C23.3197 7.87062 23.544 8.09593 23.544 8.37387V17.001C23.544 19.8864 24.7981 21.3482 27.2741 21.3482C30.3849 21.3482 32.0973 19.5903 32.0973 16.3995V8.37147C32.0973 8.09353 32.3216 7.86823 32.5984 7.86823Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.8927 8.15106H39.9274C39.6506 8.15106 39.4262 8.37637 39.4262 8.65431V23.7183C39.4262 23.8517 39.4791 23.9795 39.5731 24.0737C39.6671 24.1679 39.7946 24.2207 39.9274 24.2204H41.8927C42.0255 24.2207 42.153 24.1679 42.247 24.0737C42.341 23.9795 42.3938 23.8517 42.3938 23.7183V8.65431C42.3938 8.37637 42.1695 8.15106 41.8927 8.15106Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.8927 8.15106H39.9274C39.6506 8.15106 39.4262 8.37637 39.4262 8.65431V23.7183C39.4262 23.8517 39.4791 23.9795 39.5731 24.0737C39.6671 24.1679 39.7946 24.2207 39.9274 24.2204H41.8927C42.0255 24.2207 42.153 24.1679 42.247 24.0737C42.341 23.9795 42.3938 23.8517 42.3938 23.7183V8.65431C42.3938 8.37637 42.1695 8.15106 41.8927 8.15106Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.8927 8.15106H39.9274C39.6506 8.15106 39.4262 8.37637 39.4262 8.65431V23.7183C39.4262 23.8517 39.4791 23.9795 39.5731 24.0737C39.6671 24.1679 39.7946 24.2207 39.9274 24.2204H41.8927C42.0255 24.2207 42.153 24.1679 42.247 24.0737C42.341 23.9795 42.3938 23.8517 42.3938 23.7183V8.65431C42.3938 8.37637 42.1695 8.15106 41.8927 8.15106Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M94.1677 7.62499C91.9289 7.56371 89.7599 8.41097 88.1508 9.97535C86.5417 11.5398 85.6283 13.6893 85.6169 15.9382C85.6169 20.4854 89.4103 24.3257 93.9005 24.3257C96.9033 24.335 99.6758 22.711 101.146 20.0817C101.234 19.9246 101.232 19.7322 101.14 19.5772C101.051 19.4235 100.886 19.3293 100.709 19.3304H98.0768L98.0017 19.4262C97.0277 20.7158 95.5121 21.4773 93.9005 21.4872C91.4746 21.4872 89.3542 19.7365 88.7504 17.2838H101.683C101.959 17.2838 102.183 17.0592 102.184 16.7818V16.1C102.184 11.5683 98.5876 7.76518 94.1677 7.6226V7.62499ZM88.7552 14.5196C89.3817 12.1135 91.4567 10.4588 93.9005 10.4588C96.3049 10.4588 98.4216 12.1482 99.0457 14.5196H88.7552Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M94.1677 7.62499C91.9289 7.56371 89.7599 8.41097 88.1508 9.97535C86.5417 11.5398 85.6283 13.6893 85.6169 15.9382C85.6169 20.4854 89.4103 24.3257 93.9005 24.3257C96.9033 24.335 99.6758 22.711 101.146 20.0817C101.234 19.9246 101.232 19.7322 101.14 19.5772C101.051 19.4235 100.886 19.3293 100.709 19.3304H98.0768L98.0017 19.4262C97.0277 20.7158 95.5121 21.4773 93.9005 21.4872C91.4746 21.4872 89.3542 19.7365 88.7504 17.2838H101.683C101.959 17.2838 102.183 17.0592 102.184 16.7818V16.1C102.184 11.5683 98.5876 7.76518 94.1677 7.6226V7.62499ZM88.7552 14.5196C89.3817 12.1135 91.4567 10.4588 93.9005 10.4588C96.3049 10.4588 98.4216 12.1482 99.0457 14.5196H88.7552Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M94.1677 7.62499C91.9289 7.56371 89.7599 8.41097 88.1508 9.97535C86.5417 11.5398 85.6283 13.6893 85.6169 15.9382C85.6169 20.4854 89.4103 24.3257 93.9005 24.3257C96.9033 24.335 99.6758 22.711 101.146 20.0817C101.234 19.9246 101.232 19.7322 101.14 19.5772C101.051 19.4235 100.886 19.3293 100.709 19.3304H98.0768L98.0017 19.4262C97.0277 20.7158 95.5121 21.4773 93.9005 21.4872C91.4746 21.4872 89.3542 19.7365 88.7504 17.2838H101.683C101.959 17.2838 102.183 17.0592 102.184 16.7818V16.1C102.184 11.5683 98.5876 7.76518 94.1677 7.6226V7.62499ZM88.7552 14.5196C89.3817 12.1135 91.4567 10.4588 93.9005 10.4588C96.3049 10.4588 98.4216 12.1482 99.0457 14.5196H88.7552Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.9929 5.85765H39.8272C39.7207 5.85797 39.6185 5.81565 39.5433 5.74008C39.4681 5.66451 39.4259 5.56192 39.4262 5.45505V3.28028C39.4262 3.05794 39.6057 2.87769 39.8272 2.87769H41.9929C42.214 2.87834 42.3932 3.05821 42.3939 3.28028V5.45505C42.3939 5.6774 42.2144 5.85765 41.9929 5.85765Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.9929 5.85765H39.8272C39.7207 5.85797 39.6185 5.81565 39.5433 5.74008C39.4681 5.66451 39.4259 5.56192 39.4262 5.45505V3.28028C39.4262 3.05794 39.6057 2.87769 39.8272 2.87769H41.9929C42.214 2.87834 42.3932 3.05821 42.3939 3.28028V5.45505C42.3939 5.6774 42.2144 5.85765 41.9929 5.85765Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M41.9929 5.85765H39.8272C39.7207 5.85797 39.6185 5.81565 39.5433 5.74008C39.4681 5.66451 39.4259 5.56192 39.4262 5.45505V3.28028C39.4262 3.05794 39.6057 2.87769 39.8272 2.87769H41.9929C42.214 2.87834 42.3932 3.05821 42.3939 3.28028V5.45505C42.3939 5.6774 42.2144 5.85765 41.9929 5.85765Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M103.705 23.3361H105.872C106.093 23.3361 106.272 23.1562 106.272 22.9346V20.7598C106.272 20.6532 106.231 20.5507 106.156 20.4752C106.08 20.3997 105.979 20.3572 105.872 20.3572H103.705C103.599 20.3572 103.497 20.3997 103.422 20.4752C103.347 20.5507 103.305 20.6532 103.306 20.7598V22.9346C103.306 23.1562 103.485 23.3361 103.705 23.3361Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M103.705 23.3361H105.872C106.093 23.3361 106.272 23.1562 106.272 22.9346V20.7598C106.272 20.6532 106.231 20.5507 106.156 20.4752C106.08 20.3997 105.979 20.3572 105.872 20.3572H103.705C103.599 20.3572 103.497 20.3997 103.422 20.4752C103.347 20.5507 103.305 20.6532 103.306 20.7598V22.9346C103.306 23.1562 103.485 23.3361 103.705 23.3361Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M103.705 23.3361H105.872C106.093 23.3361 106.272 23.1562 106.272 22.9346V20.7598C106.272 20.6532 106.231 20.5507 106.156 20.4752C106.08 20.3997 105.979 20.3572 105.872 20.3572H103.705C103.599 20.3572 103.497 20.3997 103.422 20.4752C103.347 20.5507 103.305 20.6532 103.306 20.7598V22.9346C103.306 23.1562 103.485 23.3361 103.705 23.3361Z",
            fill: l
          }
        )
      ]
    }
  );
}, n = ({ variant: i, width: e = 40, height: d = 40 }) => {
  const t = {
    brand: {
      textColor: "#fff",
      backgroundColor: "#CB0000"
    },
    light: {
      textColor: "#CB0000",
      backgroundColor: "#fff"
    },
    dark: {
      textColor: "#fff",
      backgroundColor: "#090C10"
    }
  }, { textColor: l, backgroundColor: o } = t[i];
  return /* @__PURE__ */ V(
    "svg",
    {
      width: e,
      height: d,
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ V("g", { clipPath: "url(#clip0_1083_50505)", children: [
          /* @__PURE__ */ C(
            "rect",
            {
              width: 32,
              height: 32,
              rx: 16,
              fill: l
            }
          ),
          /* @__PURE__ */ C(
            "rect",
            {
              width: 32,
              height: 32,
              rx: 16,
              fill: o
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M19.0093 7.20733H20.4674C20.6728 7.20733 20.8394 7.37831 20.8394 7.58919V18.1403C20.8394 20.3636 20.2131 22.1737 19.0282 23.3752C17.9507 24.4671 16.4505 25.0451 14.6894 25.0451C13.6371 25.0468 12.6018 24.7718 11.6824 24.2463C11.5883 24.1914 11.5221 24.0972 11.5012 23.9882C11.4803 23.8792 11.5066 23.7662 11.5734 23.6787L12.4452 22.5347C12.5555 22.3886 12.7524 22.3457 12.9109 22.4332C13.4586 22.7335 14.07 22.8905 14.6909 22.8904C17.31 22.8904 18.638 21.2921 18.638 18.1403V17.842C17.5466 18.9553 16.0726 19.5837 14.534 19.5917C11.1392 19.588 8.388 16.764 8.384 13.279C8.384 9.8274 11.2 6.91199 14.534 6.91199C16.056 6.91199 17.5272 7.56084 18.638 8.70792V7.58919C18.6378 7.48799 18.6769 7.39085 18.7465 7.31922C18.8161 7.24758 18.9107 7.20733 19.0093 7.20733ZM10.5868 13.279C10.5868 15.6112 12.2977 17.4377 14.4816 17.4377C16.7062 17.4377 18.585 15.524 18.585 13.279C18.585 11.0341 16.6677 9.06592 14.4816 9.06592C12.3341 9.06592 10.5868 10.9469 10.5868 13.279Z",
              fill: l
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M23.6976 20.5264C24.6616 20.5264 25.443 19.7449 25.443 18.781C25.443 17.817 24.6616 17.0355 23.6976 17.0355C22.7336 17.0355 21.9521 17.817 21.9521 18.781C21.9521 19.7449 22.7336 20.5264 23.6976 20.5264Z",
              fill: l
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_1083_50505", children: /* @__PURE__ */ C(
          "rect",
          {
            width: 32,
            height: 32,
            rx: 16,
            fill: l
          }
        ) }) })
      ]
    }
  );
}, p = ({ type: i, variant: e, ...d }) => i === "full" ? /* @__PURE__ */ C(
  f,
  {
    variant: e,
    ...d
  }
) : /* @__PURE__ */ C(
  n,
  {
    variant: e,
    ...d
  }
);
export {
  p as L
};
